const updates = [
  { time: '2分钟前', title: '台北娜娜微博小号被网友扒出，内容信息量巨大', tag: '最新' },
  { time: '18分钟前', title: '莫里秀团队发布正式律师函，将对造谣者追究法律责任', tag: '快讯' },
  { time: '1小时前', title: '玩偶姐姐新账号疑似曝光，风格大变成熟路线', tag: '独家' },
  { time: '3小时前', title: '娱乐圈知名经纪人朋友圈发文暗示将有大瓜', tag: '预警' },
  { time: '5小时前', title: '多位网红集体发声回应近期争议，态度各不相同', tag: '热点' },
  { time: '8小时前', title: '某视频平台内部人员爆料热门综艺剪辑内幕', tag: '深扒' },
  { time: '12小时前', title: '51吃瓜大赛独家整理：本周十大必吃大瓜汇总', tag: '精选' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时更新，永不掉线，第一时间掌握吃瓜动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-2 bottom-2 w-0.5 bg-background-300"></div>

          <div className="space-y-4">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 pl-10 md:pl-12">
                <div className={`absolute left-3 md:left-4 w-2.5 h-2.5 md:w-3 md:h-3 rounded-full border-2 border-background-100 ${
                  i === 0 ? 'bg-primary-500' : 'bg-background-300'
                }`}></div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                    <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full whitespace-nowrap ${
                      item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '独家' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '快讯' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-background-200 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <a
                    href="#cards"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm md:text-base text-foreground-950 font-medium hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {item.title}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}